<template>
  <div>
    <v-form ref="form" v-model="valid" @submit.prevent="action">
      <v-row align-items="center">
        <v-col>
          <matrix-input-file :max="10" />
        </v-col>

        <v-col class="flex-grow-0">
          <div class="d-inline-flex">
            <v-btn type="submit" :disabled="isSubmitDisabled" color="primary" medium @click="validate">
              {{ actionText }}
            </v-btn>
            <download-all-button v-if="hasMultipleMatrix" />
          </div>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import MatrixInputFile from '@/components/matrix-input-file.vue';
import DownloadAllButton from '@/components/control-report/download-all-button.vue';
import { getMatrixCount, matrix } from '@/modules/matrix';

export default Vue.extend({
  components: {
    MatrixInputFile,
    DownloadAllButton
  },
  data() {
    return {
      valid: false
    };
  },
  props: {
    actionText: {
      type: String,
      required: true
    },
    action: {
      type: Function,
      required: true
    }
  },
  computed: {
    hasMultipleMatrix(): boolean {
      return getMatrixCount() > 1;
    },
    form(): HTMLFormElement {
      return this.$refs.form as HTMLFormElement;
    },
    isSubmitDisabled(): boolean {
      return !this.valid || getMatrixCount() === 0 || matrix.isLoading;
    }
  },
  methods: {
    validate(event: Event) {
      const isFormValid = this.form.validate();
      if (!isFormValid) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }
});
</script>

<style lang="scss" scoped>
form {
  margin-bottom: 20px;

  & > div {
    align-items: center;
  }
}
</style>
